import { IconActionChevronLeft16, IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

type TDirection = -1 | 1;

interface IArrowProps {
  direction: TDirection;
  ref: React.Ref<HTMLDivElement>;
  className?: string;
}

export const Arrow = ({ direction, ref, className }: IArrowProps) => {
  return (
    <div
      data-testid="newbuilding_promo_carousel_arrow"
      ref={ref}
      className={classNames(styles['click_area'], direction < 0 && styles['click_area--left'], className)}
    >
      <div className={styles['background']}>
        <div className={styles['icon_container']}>
          <div className={styles['icon']}>
            {direction < 0 ? (
              <IconActionChevronLeft16 data-testid="icon_arrow_left" color="icon-secondary-default" />
            ) : (
              <IconActionChevronRight16 data-testid="icon_arrow_right" color="icon-secondary-default" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

Arrow.displayName = 'Arrow';
